module.exports = __webpack_public_path__ + "static/media/check_white.1aaa5674.svg";